import { createSelector } from "reselect";

export const getPageSize = (state) => {
  return state.usersPage.pageSize;
}

export const getPortionSize = (state) => {
  return state.usersPage.portionSize;
}

export const getTotalUsersCount = (state) => {
  return state.usersPage.totalUsersCount;
}

export const getCurrentPage = (state) => {
  return state.usersPage.currentPage;
}

export const getIsFetching = (state) => {
  return state.usersPage.isFetching;
}

export const getFollowingInProgress = (state) => {
  return state.usersPage.followingInProgress;
}

export const getUsers = (state) => {
  return state.usersPage.users;
}

export const getUserSelector = (state) => {
  getUsers(state).filter(u => true)
}

export const getUserSuper = createSelector(getUsers, (state) => state)